import { Component } from '@angular/core';

import { EndorsementBase } from '../../models';

@Component({
    selector: 'app-initials-endorsement',
    templateUrl: './initials-endorsement.component.html',
    styleUrls: ['./initials-endorsement.component.scss'],
    standalone: false
})
export class InitialsEndorsementComponent extends EndorsementBase {
  constructor() {
    super();
  }

  endorsementClicked(): void {
    this.signEndorsement.emit({
      endorsementLocationId: this.endorsementLocation.documentEndorsementLocationId,
      endorsementType: this.endorsementLocation.endorsementTypeCode,
      packageUserGuid: this.endorsementLocation.packageUserGuid,
    });
  }

  eraseEndorsementClicked(): void {
    this.eraseSignedEndorsement.emit({
      endorsementLocationId: this.endorsementLocation.documentEndorsementLocationId,
      endorsementType: this.endorsementLocation.endorsementTypeCode,
      packageUserGuid: this.endorsementLocation.packageUserGuid,
    });
  }

  get shouldDisable() {
    return this.isEndorsementDisabled || this.areAllEndorsementsSigned;
  }
}
